import '../../../base_builders/vertical/rcp/rcp_base_builder';

//Its required for comments
import RcmgSpot from '../../../../assets/js/RCMG_V2/RcmgSpot.js';

import VideosInit from "../../../../assets/js/Videos/Videos";
VideosInit();

import VideoCalendarConfig from '../../../../assets/js/YCalendar/VideoCalendarConfigs';
VideoCalendarConfig();

import Chartbeat from '../../../../assets/js/Analytics/Chartbeat.js';
Chartbeat();